module.exports = __webpack_public_path__ + "static/screenshot-821ce73d43413f735730cd72e9c7323e.png";